// Screens search engines should skip: login and private app screens, and
// /user/register, whose content becomes the indexable home page (plan B2.5).
// noindex, not robots.txt Disallow, so crawlers can fetch the page and see
// the tag. See docs/plans/SITEMAP_OPTIMIZATION.md B2.1.
const NOINDEX_PATHS = [
    "/dashboard",
    "/community",
    "/settings",
    "/join",
    "/user/login",
    "/user/register",
    "/user/forgot-password",
    "/user/reset-password",
]

export function isNoIndexPath(pathname) {
    return NOINDEX_PATHS.some(
        (path) => pathname === path || pathname.startsWith(`${path}/`),
    )
}
